import { RegisterProps } from "../types/register";

export const useCaptchaHandlers = (props: RegisterProps) => {
    const { methods, recaptcha } = props;
    const { setError, clearErrors, setValue } = methods;

    const verifyCaptcha = (): boolean => {
        const recaptchaValue = recaptcha.current?.getValue();
        if (!recaptchaValue) {
            setError("recaptcha", {
                type: "custom",
                message: "Please verify the reCAPTCHA!",
            });
            return false;
        } else {
            clearErrors("recaptcha");
            return true;
        }
    };

    const onChangeRecaptcha = async (token: string | null): Promise<void> => {
        const recaptchaValue = recaptcha.current?.getValue();
        setValue("recaptcha", recaptchaValue);
        verifyCaptcha();
        // TODO: Verify response by sending token to back-end API
    };

    return { verifyCaptcha, onChangeRecaptcha };
};
